(function () {
  // const rangeOptions = [
  //   ...document.querySelectorAll(".card-rental .flex-select-option label"),
  // ];
  // const oldRangeContainer = document.querySelector(
  //   ".card-rental .flex-select-option",
  // );

  // const rangeSelector = document.createElement("select");
  // rangeSelector.classList.add("form-control", "form-control--select");
  // rangeSelector.name = "select-range-dropdown";
  // for (const labelOption of rangeOptions) {
  //   const input = labelOption.querySelector("input");
  //   const inputValue = input.value;

  //   const option = document.createElement("option");
  //   option.textContent = labelOption.textContent;
  //   option.value = input.getAttribute("data-duration-id");
  //   rangeSelector.append(option);
  // }

  // console.log(rangeSelector);

  // rangeSelector.addEventListener("change", function (event) {
  //   const targetDuration = event.target.value;
  //   const targetOption = document.querySelector(
  //     `.card-rental .flex-select-option input[data-duration-id="${targetDuration}"]`,
  //   );

  //   targetOption.checked = true;
  // });

  // oldRangeContainer.before(rangeSelector);
  // oldRangeContainer.style.display = "none";
  // rangeSelector.style.margin = "20px 0";
})();
(function() {
    const rangeOptions = [
    ...document.querySelectorAll(".card-rental .flex-select-option label"),
  ];
  const oldRangeContainer = document.querySelector(
    ".card-rental .flex-select-option",
  );

  const rangeSelector = document.createElement("select");
  rangeSelector.classList.add("form-control", "form-control--select");
  rangeSelector.name = "select-range-dropdown";
  
  for (const labelOption of rangeOptions) {
    const input = labelOption.querySelector("input");
    const option = document.createElement("option");
    option.textContent = labelOption.textContent.trim();
    option.value = input.getAttribute("data-duration-id");
    
    if (input.checked) {
      option.selected = true;
    }
    
    rangeSelector.append(option);
  }

  rangeSelector.addEventListener("change", function (event) {
    const targetDuration = event.target.value;
    const targetOption = document.querySelector(
      `.card-rental .flex-select-option input[data-duration-id="${targetDuration}"]`
    );

    if (targetOption) {
      targetOption.checked = true;

      const clickEvent = new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      });
      targetOption.dispatchEvent(clickEvent);

      const changeEvent = new Event("change", { bubbles: true });
      targetOption.dispatchEvent(changeEvent);
    }
  });

  oldRangeContainer.before(rangeSelector);
  oldRangeContainer.style.display = "none";
  rangeSelector.style.margin = "20px 0";
})();